import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { loadMoyasar } from "../lib/moyasar";

const PK = process.env.REACT_APP_MOYASAR_PUBLISHABLE_KEY;

export default function Payment() {
    const { orderNumber } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [error, setError] = useState("");
    const [ready, setReady] = useState(false);
    const failedMsg = params.get("failed") ? params.get("message") || "لم تتم عملية الدفع، حاول مرة أخرى" : "";

    useEffect(() => {
        api.get(`/orders/${orderNumber}`)
            .then((r) => {
                if (r.data.payment_status === "paid") navigate(`/order/${orderNumber}`, { replace: true });
                else setOrder(r.data);
            })
            .catch(() => setError("تعذر تحميل الطلب"));
    }, [orderNumber, navigate]);

    useEffect(() => {
        if (!order) return;
        if (!PK) {
            setError("بوابة الدفع غير مهيأة بعد");
            return;
        }
        let cancelled = false;
        loadMoyasar()
            .then((Moyasar) => {
                if (cancelled) return;
                const el = document.querySelector(".mysr-form");
                if (el) el.innerHTML = "";
                Moyasar.init({
                    element: ".mysr-form",
                    amount: Math.round(order.total * 100),
                    currency: "SAR",
                    language: "ar",
                    description: `طلب تسالي سكة 10 رقم ${order.order_number}`,
                    publishable_api_key: PK,
                    callback_url: `${window.location.origin}/payment/callback`,
                    methods: ["applepay", "creditcard"],
                    supported_networks: ["mada", "visa", "mastercard"],
                    metadata: { order_number: order.order_number },
                    apple_pay: {
                        country: "SA",
                        label: "تسالي سكة 10",
                        validate_merchant_url: "https://api.moyasar.com/v1/applepay/initiate",
                    },
                    on_completed: async (payment) => {
                        await api.post("/payments/attach", { order_number: order.order_number, payment_id: payment.id });
                    },
                });
                setReady(true);
            })
            .catch(() => setError("تعذر تحميل نموذج الدفع، تحقق من الاتصال"));
        return () => {
            cancelled = true;
        };
    }, [order]);

    return (
        <div data-testid="payment-page" className="max-w-md mx-auto md:max-w-xl px-4 py-6">
            <h1 className="section-title text-3xl mb-2">الدفع</h1>
            <p className="text-text-muted text-sm mb-5">ادفع بأمان عبر Apple Pay أو مدى أو البطاقة الائتمانية</p>

            {order && (
                <div className="surface-card p-4 mb-4 flex items-center justify-between" data-testid="payment-summary">
                    <div>
                        <div className="text-text-muted text-xs">رقم الطلب</div>
                        <div className="text-brand font-black text-xl" data-testid="payment-order-number">{order.order_number}</div>
                    </div>
                    <div className="text-left">
                        <div className="text-text-muted text-xs">المبلغ المطلوب</div>
                        <div className="text-2xl font-black text-text-main" data-testid="payment-amount">
                            {order.total.toFixed(2)} ر.س
                        </div>
                    </div>
                </div>
            )}

            {failedMsg && (
                <div data-testid="payment-failed-alert" className="surface-card p-3 mb-4 border-2 border-red-200 bg-red-50 text-red-700 text-sm font-bold">
                    <i className="fa-solid fa-circle-exclamation ms-1" /> {failedMsg}
                </div>
            )}

            {error && (
                <div data-testid="payment-error" className="surface-card p-4 text-center text-red-600 font-bold">
                    {error}
                    <Link to="/" className="btn-brand block mt-4">العودة للرئيسية</Link>
                </div>
            )}

            {!error && (
                <div className="surface-card p-4" data-testid="payment-form-card">
                    {!ready && (
                        <div className="text-center text-text-muted py-8" data-testid="payment-loading">
                            <i className="fa-solid fa-spinner fa-spin text-2xl text-brand" />
                            <p className="mt-2 text-sm">جاري تحميل نموذج الدفع الآمن...</p>
                        </div>
                    )}
                    <div className="mysr-form" dir="ltr" data-testid="moyasar-form" />
                    <div className="mt-4 flex items-center justify-center gap-3 text-text-muted text-xs">
                        <i className="fa-solid fa-lock" /> مدفوعات مشفرة وآمنة عبر ميسر
                    </div>
                </div>
            )}
        </div>
    );
}
